import { AxiosRequestConfig } from 'axios'
import { Get } from './Get'
import { Post } from './Post'
import { Put } from './Put'
import { Patch } from './Patch'
import { Delete } from './Delete'
import { SYSTEM_CONSTANT } from '~/constants/system-constant'
import {
  CreateLoginCarouselItemDto,
  UpdateLoginCarouselItemDto,
} from './LoginBranding.interface'

// Route lồng dưới OpenIddictApplications (backend LoginCarouselItemsController) — không phải resource
// đứng riêng, luôn cần applicationId để chặn thao tác chéo application (server verify lại, đây chỉ là URL).
class LoginBrandingServiceController {
  private urlFor(applicationId: string) {
    return `${SYSTEM_CONSTANT.IDENTITY_SERVER_URL}/OpenIddictApplications/${applicationId}/carousel-items`
  }

  public Get = {
    getAll: (applicationId: string, options: AxiosRequestConfig = {}) =>
      Get(this.urlFor(applicationId), options),
  }

  public Post = {
    create: (
      applicationId: string,
      data: CreateLoginCarouselItemDto,
      options: AxiosRequestConfig = {},
    ) => Post(this.urlFor(applicationId), data, options),
  }

  public Put = {
    update: (
      applicationId: string,
      itemId: number,
      data: UpdateLoginCarouselItemDto,
      options: AxiosRequestConfig = {},
    ) => Put(`${this.urlFor(applicationId)}/${itemId}`, data, options),
  }

  public Patch = {
    setActive: (
      applicationId: string,
      itemId: number,
      isActive: boolean,
      options: AxiosRequestConfig = {},
    ) => Patch(`${this.urlFor(applicationId)}/${itemId}/active`, { isActive }, options),
    setDisplayOrder: (
      applicationId: string,
      itemId: number,
      displayOrder: number,
      options: AxiosRequestConfig = {},
    ) => Patch(`${this.urlFor(applicationId)}/${itemId}/display-order`, { displayOrder }, options),
  }

  public Delete = {
    delete: (applicationId: string, itemId: number, options: AxiosRequestConfig = {}) =>
      Delete(`${this.urlFor(applicationId)}/${itemId}`, {}, options),
    deleteImage: (applicationId: string, itemId: number, options: AxiosRequestConfig = {}) =>
      Delete(`${this.urlFor(applicationId)}/${itemId}/image`, {}, options),
  }

  // multipart/form-data riêng cho ảnh nền — cùng lý do OpenIddictApplicationService.UploadLogo.
  public UploadImage = (
    applicationId: string,
    itemId: number,
    file: File,
    options: AxiosRequestConfig = {},
  ) => {
    const formData = new FormData()
    formData.append('image', file)
    return Post(`${this.urlFor(applicationId)}/${itemId}/image`, formData, options)
  }
}

export const LoginBrandingService = new LoginBrandingServiceController()
